import { render, staticRenderFns } from "./index.vue?vue&type=template&id=671cdf14&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=671cdf14&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=671cdf14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671cdf14",
  null
  
)

export default component.exports